/* eslint-disable import/no-anonymous-default-export */
export default (debug, compName) => {
  return debug ?
    (...args) => console.log(...[`<${compName}/> Debug Log: `, ...args]) :
    () => {};
};